import React, { useEffect, useContext, useState, useLayoutEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import defaultLogo from '../../../../assets/images/logo_login.png'
// import defaultLogo from '../../../../assets/images/revitalized-logo.png'
import label from '../../../../assets/i18n/en.json'

import LoginService from '../../../services/api/login.service';
import StorageService from '../../../services/session/storage.service';
import ProviderService from '../../../services/api/provider.service';
import AccessRightsService from '../../../services/api/access-rights.service';
import ToasterService from '../../../services/api/toaster.service';

import StorageType from '../../../services/session/storage.enum';


import { store } from '../../../context/StateProvider';
import { skin } from '../../../context/SkinProvider';
import LoginLoader from './LoginLoader/LoginLoader';
import { Transition } from 'semantic-ui-react';
import toast from 'react-hot-toast';
import ThemeService from '../../../services/api/theme.service';
import SettingsService from '../../../services/api/settings.service';

import APIResponse from '../../templates/components/APIResponse'
import CacheUtilities from '../../../services/cache/CacheUtilities';
import { onLoginSuccess } from '../../../services/commonservice/login.utility';

const Login = (props) => {
    const [isLoaderTheme, setIsLoaderTheme] = useState(false)
    const [isLoaderLogo, setIsLoaderLogo] = useState(false)
    const [isLoggingIn, setIsLoggingIn] = useState(false)

    const [logo, setLogo] = useState()

    const [loginData, setLoginData] = useState({ 'sendCatalog': true, 'RememberMe': true })
    const [formErrors, setFormErrors] = useState({})
    const [showPassword, setShowPassword] = useState(false)

    const [showGuestUserMessage, setShowGuestUserMessage] = useState(false)
    const [showGuestUserErrorMessage, setShowGuestUserErrorMessage] = useState(false)

    const [apiResponse,setApiResponse] = useState()

    const globalStateAndDispatch = useContext(store)
    const contextState = globalStateAndDispatch.state
    const contextDispatch = globalStateAndDispatch.dispatch
    const skinStateAndDispatch = useContext(skin)
    const skinState = skinStateAndDispatch.state
    const skinDispatch = skinStateAndDispatch.dispatch
    const [show, setShow] = useState(false)
    const params = useParams()

    const navigate = useNavigate()

    const getSkin = (providerName) => {
        LoginService.getLogoTheme(providerName)
            .then(res => { return res })
    }
    const getLogoCall = () => {
        SettingsService.getProviderSettingsLogo(params.providerName)
            .then(res => {
                if (res?.data?.logo) {
                    // console.log(res.data.logo)
                    setLogo(res.data.logo)
                    setIsLoaderLogo(false)
                }
                else {
                    navigate("../login")
                    setIsLoaderLogo(false)
                }
            })
    }
    useLayoutEffect(() => {
        setIsLoaderLogo(true)
        if (params.providerName !== "" && params.providerName && params.providerName !== "undefined") {
            let results = getSkin(params.providerName)
            SettingsService.getProviderSettingsSkin(params.providerName)
                .then(res => {
                    if (res?.data?.skin) {
                        // console.log(res.data.skin)
                        ThemeService.changeTheme(res.data.skin)
                    }
                    else {
                        navigate('../login')
                    }
                })
            if (results?.logo) {
                setLogo(results?.logo)
                setIsLoaderLogo(false)
            }
            else {
                getLogoCall()
            }
        }
        else { setLogo(defaultLogo);
        ThemeService.changeTheme(7);
        setIsLoaderLogo(false) }
    }, [params])

    const getLogo = () => {
        let logoPath = StorageService.getLogo(contextState.practiceLocationId);
        if (logoPath) {
          setLogo(logoPath)
        }
        else {
          setLogo(defaultLogo)
        }
      }
    // useEffect(() => {
    //     getLogo()
    // }, [])

    useEffect(async () => {
        if (StorageService.get('session', 'guestUser')) {
            setIsLoggingIn(true)
            let guestUser = JSON.parse(StorageService.get('session', 'guestUser'));
            if (guestUser !== undefined && guestUser !== null && guestUser !== '') {
                StorageService.remove('session', 'guestUser');
                await handleLoginResponse(guestUser);
            }
        }
    }, [StorageService.get('session', 'guestUser')])

    const onSuccess = async (message) => {
        let data ={
            "message": message,
            providerName :params.providerName, //required
            userName:loginData.userName, //required
            apiResponse: apiResponse.data //required
        }
        onLoginSuccess(data,navigate, contextDispatch, setLogo, setIsLoggingIn)
    }
    const onError = () => {
        //hiding hide loader
        setIsLoggingIn(false)
    }
    const login = (e) => {
        StorageService.remove('session', "auth");
        setIsLoggingIn(true);
        LoginService.login(loginData)
            .then(res => {
                //setIsLoggingIn(false);
                setApiResponse(res)
            })
            .catch(error => {
                setIsLoggingIn(false)  // hide loader
                setApiResponse(error)
            });
    }

    const handleLoginResponse = async (loginResponse) => {
        if (loginResponse.isEmulated === true) {
            contextDispatch({ type: 'setEmulate', payload: true })
        }
        if (loginResponse['termsConditions'] === false) {
            return;
        } else if (loginResponse['changePassword'] === true) {
            if (loginResponse.isEmulated === true) {
                return;
            }
        } else {
            StorageService.save('session', 'auth', JSON.stringify(loginResponse));
            LoginService.getloginUserDetail(loginResponse['userType'], loginResponse['userName'], loginResponse['parentId'])
                .then(userDataResponse => {
                    ProviderService.getProviderDetails(loginResponse['parentId'])
                        .then(
                            async (response) => {
                                StorageService.save('session', 'userDetails', JSON.stringify(userDataResponse));
                                StorageService.save('session', "providerSelected", JSON.stringify(response));
                                AccessRightsService.getModuleDetails(userDataResponse);
                                let details = response;
                                let providerSettings = {
                                    logo: details.logo,
                                    skin: details.skin,
                                    providerName: details.providerUrlSuffix,
                                    practiceLocationDetails: details.practiceLocation
                                };
                                StorageService.save('session', "settingsData", JSON.stringify(providerSettings));

                                await CacheUtilities.pullAndCachePracticeAndLocationData(details.practiceLocation[0].practiceLocationId,contextDispatch);

                                return navigate('/provider')
                            })
                        .catch(
                            (error) => {
                                setIsLoggingIn(false); // hide loader
                                ThemeService.changeTheme(7);
                            }
                        )
                })
        }
    }

    // formula for input change
    const inputChange = (e) => {
        e.preventDefault()
        let newStateObject = { ...loginData };
        newStateObject[e.target.name] = e.target.value;
        setLoginData(newStateObject);
        // console.log("new data", loginData);
    };

    useEffect(() => {
        setInterval(() => {
            setShow(true)
        }, 200)
        // getLogo()
    }, [])

    
    const forgotPasswordDirect = () =>{
        if(loginData?.userName){
            navigate(`/forgot-password?username=${loginData.userName}`)
        }
        else {
            navigate('/forgot-password')
        }
    }
    return (
        <div className="limiter">
            {isLoggingIn &&
                <LoginLoader logo={logo} />
            }
            <div className="container-login100 img-bg">
                <Transition.Group animation="drop" duration={600}>
                    {show && <div className="wrap-login100 d-flex row">
                        {!isLoaderLogo && <img className="logo-center" src={logo ? logo : defaultLogo} />}
                        <br />
                        {!isLoaderTheme && <div className="ui segment" id="login-box">
                            <h2>Login</h2>
                            {/* {showGuestUserMessage & !showGuestUserErrorMessage && <h4>{label.login.emulateLoad}</h4>} */}
                            {showGuestUserErrorMessage && <h4> {label.login.emulateError} </h4>}
                            {!showGuestUserMessage &&
                                <form onSubmit={e => { e.preventDefault(); login(e); }} className="login-box__input row d-flex">
                                    <div className="required field col-12">
                                        <label>{label.login.userName}</label>
                                        <div className="ui left icon input w-100">
                                            <i className="user icon ms-2 my-0"></i>
                                            <input type="text" placeholder="username" name="userName" value={loginData.userName} onChange={e => { inputChange(e) }} />
                                        </div>
                                        <span className="invalid-feedback">
                                            <span className="error-msg">
                                                {formErrors.userName && formErrors.userName}
                                            </span>
                                        </span>
                                    </div>
                                    <div className="required field col-12">
                                        <label>{label.login.password}</label>
                                        <div className="ui left icon input w-100 password-field">
                                            <i className="lock icon ms-2 password-field"></i>
                                            <input type={showPassword ? 'text' : 'password'} placeholder="password" name="password" value={loginData.password} onChange={e => { inputChange(e) }} />
                                            <a className="ui icon view-pw">
                                                <i onClick={e => { e.preventDefault(); showPassword ? setShowPassword(false) : setShowPassword(true) }} className={showPassword ? 'eye icon text-decoration-none' : 'low vision icon text-decoration-none'}></i>
                                            </a>
                                        </div >
                                        <span className="error-msg">
                                            {formErrors.password && formErrors.password}
                                        </span>
                                    </div >
                                    <div className='row-fluid  d-flex align-items-center justify-content-left'>
                                        <button type="submit" onClick={e => { e.preventDefault(); login(e) }} className="btn btn-primary mt-3 col-auto">
                                            {label.login.submit}
                                        </button>
                                        <a href="#" onClick={e => { e.preventDefault(); forgotPasswordDirect() }} className="mx-3 col-auto mt-3">{label.login.forgotPassword} </a>
                                    </div >
                                </form>}
                        </div >}
                        <div style={{ textAlign: 'center', marginTop: '15%' }}>
                            <span><a href="https://revique.io/privacy-policy/"
                                target="_blank">{label.login.privacyPolicy}</a></span>
                        </div>
                    </div >}
                </Transition.Group>
                <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} onError={onError} toastOnSuccess={true} toastOnFailure={true} />
            </div >
        </div>
    )
}

export default Login